import { useState } from 'react'
import Button, { buttonClasses } from '@mui/material/Button'
import { useGridApiContext, useGridRootProps } from '@mui/x-data-grid-pro'
import { useFeature } from '@cbgms/base/feature-flags'
import { DataGridToolbarExportDialog } from './DataGridToolbarExportDialog'

declare module '@mui/x-data-grid-pro' {}

interface DataGridToolbarExportButtonProps {
  disabled?: boolean
}

export function DataGridToolbarExportButton({ disabled = false }: DataGridToolbarExportButtonProps) {
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const gridApiRef = useGridApiContext()
  const rootProps = useGridRootProps()
  const isInvoiceHistoryEnabled = useFeature('fr0052-enable-invoice-history')
  const isSupplierOrdersEnabled = useFeature('fr0079_enable_supplier_order')

  if (!rootProps.slotProps?.exportDialog) return null

  return (
    <>
      {isInvoiceHistoryEnabled || isSupplierOrdersEnabled ? (
        <Button
          onClick={handleOpen}
          size='small'
          startIcon={<rootProps.slots.exportIcon sx={{ opacity: disabled ? 0.3 : 1 }} />}
          variant='text'
          disabled={disabled}
          sx={{
            cursor: disabled ? 'not-allowed' : 'pointer',
            [`&.${buttonClasses.disabled}`]: {
              cursor: 'not-allowed',
              pointerEvents: 'none'
            }
          }}
        >
          {gridApiRef.current.getLocaleText('toolbarExport')}
        </Button>
      ) : (
        <Button onClick={handleOpen} size='small' startIcon={<rootProps.slots.exportIcon />} variant='text'>
          {gridApiRef.current.getLocaleText('toolbarExport')}
        </Button>
      )}

      {open && <DataGridToolbarExportDialog {...rootProps.slotProps.exportDialog} open onClose={handleClose} />}
    </>
  )
}
